import styles from './AdPanel.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import HoustonAd from 'HoustonAd/HoustonAd';

const scomAdId = '/18718623/SEEKAU/jobsearch_skyscraper2';

const mapStateToProps = ({ location }) => {
  return {
    locale: location.locale
  };
};

@connect(mapStateToProps)
export default class AdPanel extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  renderScom() {
    return (
      <div className={styles.scom}>
        <HoustonAd
          tagId={scomAdId}
          width={160}
          height={599}
        />
      </div>
    );
  }

  render() {
    const { locale } = this.props;
    const skyscraperId = `/18718623/SEEK${locale}/jobsearch_skyscraper`;

    return (
      <div className={styles.root}>
        <div className={styles.skyscraper}>
          <HoustonAd
            tagId={skyscraperId}
            width={160}
            height={600}
          />
        </div>
        { locale === 'AU' && this.renderScom() }
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/AdPanel/AdPanel.js
 **/